<mat-card class="margin-top: 1rem">
    <div class="subdeptHeaderContainer">
        <h2>{{langObj ? langObj?.SubDepartment : ('SubDepartment' | translate)}}</h2>
        <mat-form-field style="width: 20%">
            <input matInput placeholder="Search" autocomplete="off" [(ngModel)]="subDeptInput"
                (keyup)="gridFilterSearch()">
        </mat-form-field>
        <button mat-mini-fab mat-button color="accent" pTooltip="Add Sub Department" (click)="openSideModal()"
            tooltipPosition="top">
            <i class="fa fa-plus" style="color: #fff"></i>
        </button>
    </div>

    <table mat-table matSort matSortDirection="desc" [dataSource]="subDeptDS" (matSortChange)="sortData($event)"
        class="basic-table plant-model-table" style="margin-top: 1rem">
        <ng-container matColumnDef="Action">
            <th style="font-weight: bold;font-size: 13px;line-height: 16px;color: #0f0fd1;" mat-header-cell
                *matHeaderCellDef>{{langObj ? langObj?.Action : ('Action' | translate)}}</th>
            <td mat-cell *matCellDef="let element">
                <div class="row-action-btns">
                    <button mat-icon-button class="edit-btn" pTooltip="Edit Area" tooltipPosition="top"
                        aria-label="Edit Row" (click)="openEditModal(element.subDepartmentId)">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                                fill="white" />
                        </svg>
                    </button>
                    <button mat-icon-button class="tree-view-btn" pTooltip="Delete" tooltipPosition="top"
                        aria-label="View Row Tree" (click)="deleteSubDepartment(element.subDepartmentId)">
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                                fill="#F85439" />
                            <circle cx="17" cy="17" r="14" fill="#F85439" />
                            <path
                                d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                                fill="white" />
                        </svg>
                    </button>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="Plant">
            <th style="font-weight: bold;font-size: 13px;line-height: 16px;color: #0f0fd1;" mat-header-cell
                *matHeaderCellDef mat-sort-header="Plant">{{langObj ? langObj?.Plant : ('Plant' | translate)}} </th>
            <td mat-cell *matCellDef="let element"> {{element.plantDesc}} </td>
        </ng-container>
        <ng-container matColumnDef="Department">
            <th style="font-weight: bold;font-size: 13px;line-height: 16px;color: #0f0fd1" mat-header-cell
                *matHeaderCellDef mat-sort-header="Department"> {{langObj ? langObj?.Department : ('Department' | translate)}} </th>
            <td mat-cell *matCellDef="let element"> {{element.departmentDesc}} </td>
        </ng-container>
        <ng-container matColumnDef="SubDepartment">
            <th style="font-weight: bold;font-size: 13px;line-height: 16px;color: #0f0fd1;" mat-header-cell
                *matHeaderCellDef mat-sort-header="SubDepartment"> {{langObj ? langObj?.SubDepartment : ('SubDepartment' | translate)}} </th>
            <td mat-cell *matCellDef="let element"> {{element.subDepartmentDesc}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="subDeptColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: subDeptColumns;"></tr>
    </table>
    <mat-paginator #matPaginator class="basic-paginataor" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>

</mat-card>

<div class="sidepanel-model-wrapper edit-plant-row-model" [ngClass]="{ active: displaySideBar }">
    <div class="sidepanel-close" (click)="closeSideModal()"></div>
    <div class="model-content">
        <div class="model-top">
            <h2 class="model-title">{{editMode == false ? 'Add' : 'Edit'}} Sub Department</h2>

            <button mat-icon-button class="model-close-btn" aria-label="Close model" (click)="closeSideModal()">
                <svg width="14" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
                        fill="black" />
                </svg>
            </button>
        </div>
        <div class="model-body">
            <form [formGroup]="subDepartmentForm">
                <div class="content-row-wrap content-top-row-order-processing align-items-center d-flex just"
                    style="width: 100%;">
                    <mat-form-field appearence="fill"
                        class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width: 100%;">
                        <mat-label class="required">Select Department</mat-label>
                        <mat-select formControlName="department">
                            <mat-option *ngFor="let data of departments" [value]="data.TypeId">
                                {{data.TypeName}}
                            </mat-option>
                        </mat-select>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearence="fill"
                        class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width: 100%;">
                        <mat-label class="placeholder-title">Enter Sub Department</mat-label>
                        <input type="text" matInput formControlName="subDepartment" />
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </div>
                <button [disabled]="!subDepartmentForm.valid" (click)="editMode == false ? addSubDepartment(): editSubDepartment()" mat-mini-fab
                    color="primary" class="pull-right" type="button" title="Save Sub Department">
                    <mat-icon>save</mat-icon>
                </button>
            </form>
        </div>
    </div>
</div>